import { CustomField, TransactionCustomField } from 'types/domain';

interface CombinedField extends CustomField {
    field_id?: number;
    value: string;
    value_friendly: string;
    required: boolean;
}

const useCombinedFields = (
    campaignCustomFields: CustomField[] = [],
    ticketCustomFields: TransactionCustomField[] = [],
): CombinedField[] => {
    const allTicketsMap = campaignCustomFields.reduce<Record<number, any>>((acc, field) => {
        acc[field.id] = field;
        return acc;
    }, {});

    const answeredTicketsMap = ticketCustomFields?.reduce<Record<number, any>>((acc, field) => {
        acc[field.field_id] = { ...field, response: { id: field.id } };
        return acc;
    }, {});

    Object.values(allTicketsMap).forEach(field => {
        if (!field.public && !answeredTicketsMap[field.id]) {
            answeredTicketsMap[field.id] = {
                ...field,
                field_id: field.id,
                response: { id: field.id },
            };
        }
    });

    const allFieldsMap = { ...answeredTicketsMap, ...allTicketsMap };

    return (
        Object.values(allFieldsMap).map(field => {
            const id = field.field_id || field.id;
            const ticketField = answeredTicketsMap[id];
            const value =
                ticketField?.value !== undefined ? ticketField.value : field.default_value;
            const value_friendly = ticketField?.value_friendly || field.default_value;

            return {
                ...field,
                id,
                value,
                value_friendly,
                response: { ...field.response, value, id: ticketField?.response?.id || id },
            };
        }) || []
    );
};

export { useCombinedFields };

export type { CombinedField };
